"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _background = _interopRequireDefault(require("./background.js"));

var _icon = _interopRequireDefault(require("./icon.js"));

var _mask = _interopRequireDefault(require("./mask.js"));

var _networks = require("./networks.js");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function getNetworkKey(props) {
  return props.network || (0, _networks.keyFor)(props.url);
}

function SocialIcon(props) {
  var url = props.url,
      network = props.network,
      bgColor = props.bgColor,
      fgColor = props.fgColor,
      className = props.className;
  var networkKey = getNetworkKey({
    url: url,
    network: network
  });
  return _react["default"].createElement("svg", {
    className: "social-svg ".concat(className),
    style: {
      borderRadius: '50%'
    },
    viewBox: "0 0 64 64"
  }, _react["default"].createElement(_background["default"], null), _react["default"].createElement(_icon["default"], {
    networkKey: networkKey,
    fgColor: fgColor
  }), _react["default"].createElement(_mask["default"], {
    networkKey: networkKey,
    bgColor: bgColor
  }));
}

SocialIcon.propTypes = {
  className: _propTypes["default"].string,
  bgColor: _propTypes["default"].string,
  label: _propTypes["default"].string,
  network: _propTypes["default"].string,
  url: _propTypes["default"].string
};
var _default = SocialIcon;
exports["default"] = _default;